var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    viewBox: "0 0 60 60",
    overflow: "visible"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.1 60H5.9C2.7 60 0 57.3 0 54.1V13.7c0-3.3 2.7-5.9 5.9-5.9H54c3.3 0 5.9 2.7 5.9 5.9V54c.1 3.3-2.6 6-5.8 6zM5.9 10.7a3.01 3.01 0 0 0-3 3V54a3.01 3.01 0 0 0 3 3H54a3.01 3.01 0 0 0 3-3V13.7a3.01 3.01 0 0 0-3-3H5.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 26.3h-57A1.54 1.54 0 0 1 0 24.8a1.54 1.54 0 0 1 1.5-1.5h57a1.54 1.54 0 0 1 1.5 1.5 1.54 1.54 0 0 1-1.5 1.5zM17 15.9a1.54 1.54 0 0 1-1.5-1.5v-13C15.6.7 16.2 0 17 0a1.54 1.54 0 0 1 1.5 1.5v13c0 .8-.6 1.4-1.5 1.4zm26 0a1.54 1.54 0 0 1-1.5-1.5v-13c0-.7.6-1.4 1.5-1.4a1.47 1.47 0 0 1 1.5 1.5v13c-.1.8-.7 1.4-1.5 1.4z"
  })));
};
export default SvgCalendar;